import { SELF_URL } from '@/src/lib/core/config';

export function getSelfUrl(path?: string) {
  if (!SELF_URL) {
    throw new Error('selfUrl is not set');
  }
  return new URL(path ?? '/', SELF_URL).toString();
}
